'use strict';

exports.__esModule = true;
exports.setFactory = setFactory;
exports.create = create;

var _reporter = require('./reporter');

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReporterFactory = void 0;

function setFactory(factory) {
  ReporterFactory = factory;
}

function create() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      biLoggerFactory = _ref.biLoggerFactory,
      baseUrl = _ref.baseUrl,
      endpoint = _ref.endpoint,
      preset = _ref.preset;

  if (!ReporterFactory) {
    return new _reporter2.default({ biLoggerFactory: biLoggerFactory, baseUrl: baseUrl, endpoint: endpoint, preset: preset });
  } else {
    return ReporterFactory({ preset: preset });
  }
}